export const selectIsAuthenticated = state => state.auth.isAuthenticated

export const selectIsFetching = state => state.auth.isFetching

export const selectErrorMessage = state => state.auth.errorMessage

export const selectStatusCode = state => state.auth.statusCode
